import { useEffect, useState } from "react";

type IconProps = {
  className?: string;
  fill?: string;
};

const ArrowAboveIcon = ({ className, fill }: IconProps) => {
  const [_class, setClass] = useState(className);

  useEffect(() => {
    let classStr = className || "";
    if (!classStr.includes("w-")) {
      classStr += " w-5";
    }
    if (!classStr.includes("h-")) {
      classStr += " h-5";
    }

    setClass(classStr);
  }, [className]);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth="0"
      stroke={fill}
      className={_class}
    >
      <g clip-path="url(#clip0_177531_26138)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M22.3031 18.7584L13.2984 3.01688C13.0328 2.54458 12.533 2.2523 11.9911 2.2523C11.4492 2.2523 10.9494 2.54458 10.6838 3.01688L1.69406 18.7669C1.38919 19.311 1.4529 19.9871 1.85406 20.4647C2.25521 20.9424 2.9101 21.1219 3.49875 20.9156L11.9803 18.0094H11.9897H11.9981L20.4994 20.9156C21.09 21.1245 21.7481 20.9444 22.1501 20.4639C22.552 19.9834 22.613 19.3038 22.3031 18.7594V18.7584ZM20.9906 19.4934L12.75 16.6744V11.25C12.75 10.8358 12.4142 10.5 12 10.5C11.5858 10.5 11.25 10.8358 11.25 11.25V16.6669L3.01125 19.4944L3 19.5L11.9869 3.75L21 19.5L20.9906 19.4934Z"
          fill="#2E2E2E"
        />
      </g>
      <defs>
        <clipPath id="clip0_177531_26138">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default ArrowAboveIcon;
